import * as React from 'react';
import { observer } from 'mobx-react';
import { useSystem } from '../../hooks/useSystem';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ProfileHeaderWidget } from '../../widgets/layout/signed-in/ProfileHeaderWidget';
import { SidebarPageWidget } from '../../widgets/layout/sidebar/SidebarPageWidget';
import { UserSidebarWidget } from '../../widgets/layout/signed-in/UserSidebarWidget';
import { ProfilesPage } from './profile/ProfilesPage';
import * as path from 'path';
import { EditAvatarPage } from './profile/EditAvatarPage';
import { ProfilePage } from './profile/profile-page/ProfilePage';
import styled from '@emotion/styled';
import { MainSidebarWidget } from '../../widgets/layout/signed-in/MainSidebarWidget';
import { RegistrationCodesPage } from './profile/RegistrationCodesPage';
import { EditProfilePage } from './profile/EditProfilePage';
import { PacksPage } from './packs/PacksPage';
import { NotificationsPage } from './NotificationsPage';
import { CreatePackPage } from './packs/CreatePackPage';
import { PackPage } from './packs/pack-page/PackPage';
import { Routing } from '../Routing';
import { InvitePackMemberPage } from './packs/InvitePackMemberPage';
import { CreateGroupPage } from './groups/CreateGroupPage';
import { GroupsPage } from './groups/GroupsPage';
import { GroupPage } from './groups/GroupPage';
import { EditImagePage } from './profile/EditImagePage';
import { UploadGalleryImagePage } from './profile/UploadGalleryImagePage';

export const HomePage: React.FC = observer(() => {
  const system = useSystem();

  if (!system.user) {
    return <Navigate to={Routing.SIGN_IN} />;
  }

  return (
    <SidebarPageWidget
      sidebarLeft={({ close }) => <MainSidebarWidget close={close} />}
      sidebarRight={({ close }) => <UserSidebarWidget close={close} />}
      getContent={({ showLeft, showRight }) => {
        return (
          <S.Container>
            <S.ProfileHeader
              showMenu={() => {
                showLeft();
              }}
              showProfile={() => {
                showRight();
              }}
            />
            <Routes>
              <Route
                path="/"
                element={<Navigate to={system.user.data?.new_user ? system.user.link : Routing.PROFILES} />}
              />
              <Route path={path.relative(Routing.HOME, Routing.PROFILES)} element={<ProfilesPage />} />

              {/*Packs*/}
              <Route path={path.relative(Routing.HOME, Routing.PACK)} element={<PackPage />} />
              <Route path={path.relative(Routing.HOME, Routing.PACKS)} element={<PacksPage />} />
              <Route path={path.relative(Routing.HOME, Routing.PACK_CREATE)} element={<CreatePackPage />} />

              {/*Groups*/}
              <Route path={path.relative(Routing.HOME, Routing.GROUP_CREATE)} element={<CreateGroupPage />} />
              <Route path={path.relative(Routing.HOME, Routing.GROUPS)} element={<GroupsPage />} />
              <Route path={path.relative(Routing.HOME, Routing.GROUP)} element={<GroupPage />} />

              <Route path={path.relative(Routing.HOME, Routing.PROFILE)} element={<ProfilePage />} />
              <Route path={path.relative(Routing.HOME, Routing.EDIT_AVATAR)} element={<EditAvatarPage />} />
              <Route
                path={path.relative(Routing.HOME, Routing.UPLOAD_GALLERY_IMAGE)}
                element={<UploadGalleryImagePage />}
              />
              <Route path={path.relative(Routing.HOME, Routing.EDIT_IMAGE)} element={<EditImagePage />} />
              <Route path={path.relative(Routing.HOME, Routing.EDIT_PROFILE)} element={<EditProfilePage />} />
              <Route path={path.relative(Routing.HOME, Routing.NOTIFICATIONS)} element={<NotificationsPage />} />
              <Route
                path={path.relative(Routing.HOME, Routing.PACK_INVITE_MEMBER)}
                element={<InvitePackMemberPage />}
              />
              <Route
                path={path.relative(Routing.HOME, Routing.REGISTRATION_CODES)}
                element={<RegistrationCodesPage />}
              />
            </Routes>
          </S.Container>
        );
      }}
    />
  );
});

namespace S {
  export const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
  `;

  export const ProfileHeader = styled(ProfileHeaderWidget)`
    flex-shrink: 0;
  `;
}
